import React from 'react'

type SelectOption = {
  value: string
  label: string
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  options: SelectOption[]
  placeholder?: string
  error?: string
  helper?: string
  isClearable?: boolean
}

export const Select: React.FC<SelectProps> = ({
  label,
  options,
  placeholder = 'Select an option...',
  error,
  helper,
  className = '',
  ...props
}) => {
  const baseSelectClasses = `
    w-full h-14 px-4 py-3 border rounded-lg bg-white text-grey-text font-din-pro-regular text-base 
    focus:outline-none focus:ring-2 focus:ring-altovita focus:ring-opacity-20 transition-all duration-200
    appearance-none pr-12
    ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-border-color focus:border-altovita'}
  `

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className="font-din-pro-medium text-base text-altovita block mb-2">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <div className="relative">
        <select className={baseSelectClasses} {...props}>
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-altovita">
          <i className="fas fa-chevron-down"></i>
        </div>
      </div>

      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}

      {helper && !error && (
        <p className="mt-1 text-sm text-grey-text">{helper}</p>
      )}
    </div>
  )
}
